module.exports = __webpack_public_path__ + "img/feeder_2x.27cda805.gif";